import 'css-chunksrc/client/common/projectSection/project/managerList/styles.scss';export default {
  "resourceList": "_resourceList_1uaha_1",
  "list": "_list_1uaha_8",
  "buttonWrapper": "_buttonWrapper_1uaha_17",
  "resources": "_resources_1uaha_23",
  "hiddenTagsNbr": "_hiddenTagsNbr_1uaha_31",
  "form": "_form_1uaha_46",
  "icon": "_icon_1uaha_54"
};